import { Component, inject, NO_ERRORS_SCHEMA, OnInit, output, signal } from '@angular/core';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';

import { AppIconComponent } from '../../../../components/icon/icon.component';
import { LocalMediaPermissionService } from '../../../../services/local-media-permission.service';
@Component({
  selector: 'app-modal-permission',
  standalone: true,
  imports: [AppIconComponent],
  templateUrl: './modal-permission.component.html',
  styleUrl: './modal-permission.component.scss',
  schemas: [NO_ERRORS_SCHEMA],
})
export class ModalPermissionComponent implements OnInit {
  private localMediaPermissonService = inject(LocalMediaPermissionService);
  private nzModalData = inject(NZ_MODAL_DATA, { optional: true });

  data: {
    type: 'mic' | 'cam' | 'share-screen';
    into: 'chat' | 'meeting' | 'call';
    state: 'granted' | 'denied' | 'prompt' | 'none' | 'browser-blocked' | 'safari-blocked';
  } | null = null;
  visible = signal<boolean>(false);
  onSubmitOutput = output();

  private resolveResult: ((granted: boolean) => void) | null = null;

  constructor() {}

  ngOnInit(): void {
    if (this.nzModalData) return;
    this.localMediaPermissonService.registerModal(this);
  }

  get textPermission() {
    switch (this.data?.type) {
      case 'cam':
        return 'camera';
      case 'mic':
        return 'micro';
      case 'share-screen':
        return 'ghi màn hình';
    }
    return '';
  }

  get iconPermission() {
    switch (this.data?.type) {
      case 'cam':
        return 'popup/cam-request-icon';
      case 'mic':
        return 'popup/mic-request-icon';
      case 'share-screen':
        return 'popup/screen-request-icon';
    }
    return '';
  }

  get descriptionPermission() {
    switch (this.data?.type) {
      case 'cam':
        return 'bật video khi gọi hoặc tham gia cuộc họp. Bạn có thể bật hoặc tắt camera bất cứ lúc nào.';
      case 'mic':
        return 'nói trong cuộc gọi, cuộc họp và sử dụng các tính năng tương tác bằng giọng nói.';
      case 'share-screen':
        return 'chia sẻ nội dung với người tham gia trong cuộc gọi hoặc cuộc họp.';
    }
    return '';
  }

  open(data: {
    type: 'mic' | 'cam' | 'share-screen';
    into: 'chat' | 'meeting' | 'call';
    state: 'granted' | 'denied' | 'prompt' | 'none' | 'browser-blocked' | 'safari-blocked';
  }): Promise<boolean> {
    this.resolveResult?.(false);
    this.data = data;
    this.visible.set(true);
    return new Promise<boolean>((resolve) => {
      this.resolveResult = resolve;
    });
  }

  openSetting() {
    let link = '';
    switch (this.data?.type) {
      case 'cam':
        link = 'Camera';
        break;
      case 'mic':
        link = 'Microphone';
        break;
      case 'share-screen':
        link = 'ScreenCapture';
    }
    window.location.href = `x-apple.systempreferences:com.apple.preference.security?Privacy_${link}`;
    this.close();
  }

  close(granted = false) {
    this.visible.set(false);
    this.data = null;
    const resolve = this.resolveResult;
    this.resolveResult = null;
    resolve?.(granted);
  }
}
